module.exports = __webpack_public_path__ + "static/media/Forestry-Yellow-BG-Back-Layer-Four@2x.18310fcc.png";